import VMasker from "vanilla-masker";

export const clearPhoneFormat = (value = "") => value.replace(/[^+,\d]/g, "");

export default value => {
  if (!value || value.length === 0) return "";
  return VMasker.toPattern(value, "+9 (999) 999-99-999");
};
